import { useCallback, useState } from "react";

import { createSurvey } from "../api/survey.api";
import type { CreateSurveyRequest } from "../types/survey.types";

export const useCreateSurvey = () => {
  const [loading, setLoading] = useState(false);

  const createSurveyRequest = useCallback(async (request: CreateSurveyRequest) => {
    try {
      setLoading(true);
      return await createSurvey(request);
    } finally {
      setLoading(false);
    }
  }, []);

  return { createSurvey: createSurveyRequest, loading };
};

export type UseCreateSurveyReturn = ReturnType<typeof useCreateSurvey>;
